import React from 'react';
import { AppBar, Toolbar, Grid, Button, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import handleUtmRedirect from '../../helpers/handleUtmRedirect';
import {
  DESKTOP_NAVBAR_WRAPPER_CLASS_NAME,
  DESKTOP_NAVBAR_CLASS_NAME,
} from '../../constants/mui-components';
import NavbarProductsButton from './components/NavbarProductsButton';
import { LinkButton } from '../../components/buttons';
import { navbarButton, buttonsGrid, buttonTypography, pagesGrid } from './styles/desktop-navbar.styles';

function DesktopNavbar({ buttons, pages, Logo }) {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <AppBar className={DESKTOP_NAVBAR_WRAPPER_CLASS_NAME}>
      <Toolbar className={DESKTOP_NAVBAR_CLASS_NAME}>
        <Logo />
        <Grid xs={7} sx={pagesGrid}>
          {pages.map(({ url, title, variant, ...rest }) => {
            if (variant === 'dropDown') {
              return (
                <NavbarProductsButton
                  url={url}
                  variant={variant}
                  onClick={() => (typeof url === 'string' ? navigate(url) : url())}
                  {...rest}
                />
              );
            }
            return (
              <LinkButton
                url={url}
                title={title}
                variant={variant}
                onClick={() => (typeof url === 'string' ? navigate(url) : url())}
                {...rest}
              />
            );
          })}
        </Grid>
        <Grid item sx={buttonsGrid}>
          {buttons.map(({ title, id, url, queryParams, ...rest }) => (
            <Grid item key={title}>
              <Button
                id={`navbar-${id}-desktop`}
                sx={navbarButton(theme)}
                onClick={() => (typeof url === 'string' ? handleUtmRedirect(url, queryParams) : url())}
                {...rest}
              >
                <Typography variant="small_3" sx={buttonTypography}>
                  {title}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

DesktopNavbar.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  pages: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  Logo: PropTypes.node.isRequired,
};

export default DesktopNavbar;
